import React from 'react';
import PropTypes from 'prop-types';
import {HelpBlock} from 'react-bootstrap';

export default class FieldError extends React.Component {

    render() {
        const {message, valid} = this.props;
        return (
            <HelpBlock>{!valid ? message : ''}</HelpBlock>
        );
    }
}

FieldError.propTypes = {
    message: PropTypes.string.isRequired,
    valid: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/components/common/FieldError.js